import React from "react";
import { cloudfish, home_page_img } from "../assets";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const HomePage = () => {
  const { userInfo } = useAuth();
  const isLoggedIn = !!userInfo?.id;

  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="home-wrapper">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="logo-box me-2">
              <img src={cloudfish} alt="" />
            </div>
          </div>
          <div>
            <button className="theme-button" onClick={handleLogin}>
              {`${isLoggedIn ? "Go to chat" : "Login"}`}
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <h1 className="fw-bold mb-3 primary-text">
                Secure Hospital Chat Platform
              </h1>
              <p className="lead text-muted mb-4">
                Connect doctors, staff, and hospital teams in one secure place.
                Real-time chat designed for healthcare environments.
              </p>

              <div className="d-flex gap-3">
                <button
                  className="theme-button get-started"
                  onClick={handleLogin}
                >
                  Get Started
                </button>
              </div>
            </div>

            <div className="col-md-6 text-center">
              <div className="card p-2 shadow-lg rounded-4 illustration-card">
                <img
                  src={home_page_img}
                  alt="Chat Illustration"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section py-5 bg-light">
        <div className="container text-center">
          <h2 className="fw-bold mb-5 primary-text">Why Use CloudFish Chat?</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card p-4 shadow-sm h-100 rounded-4">
                <div className="feature-icon mb-3">🔒</div>
                <h5 className="fw-bold">Secure & Encrypted</h5>
                <p className="text-muted">
                  HIPAA-compliant chat to keep hospital communication safe.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card p-4 shadow-sm h-100 rounded-4">
                <div className="feature-icon mb-3">🏥</div>
                <h5 className="fw-bold">Hospital-Only Access</h5>
                <p className="text-muted">
                  Only verified hospital staff and users can join and chat.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card p-4 shadow-sm h-100 rounded-4">
                <div className="feature-icon mb-3">⚡</div>
                <h5 className="fw-bold">Real-Time Messaging</h5>
                <p className="text-muted">
                  Instant communication across hospital departments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer bg-white text-center py-3 shadow-sm">
        <div className="container">
          <p className="text-muted mb-0">
            © {new Date().getFullYear()} CloudFish Medical — All rights reserved
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
